import seo from '../data/seo.json';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

export default function FaqSection() {
  return (
    <section className="py-20 px-6 bg-[#F5F0E1]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto">
        <p className="text-[#8B6914] text-sm font-semibold tracking-widest uppercase mb-3">FAQ</p>
        <h2 className="font-serif text-3xl md:text-4xl text-[#1A1A1A] mb-8">Coffee Catering Questions</h2>
        <Accordion type="single" collapsible className="bg-white rounded-2xl px-6 border border-[#E8DFC9]">
          {seo.faq.map((item, idx) => (
            <AccordionItem key={idx} value={`faq-${idx}`} data-testid={`faq-item-${idx}`}>
              <AccordionTrigger className="text-left text-[#1A1A1A] font-semibold hover:no-underline">{item.q}</AccordionTrigger>
              <AccordionContent className="text-[#5C5446] leading-relaxed">{item.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
